import { React, useState } from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function SelectController(props) {
  const [register, setRegister] = useState(props);
  // const [value, setValue] = useState('');

  return (
    <Controller
      control={props.control}
      name={props.name}
      defaultValue=""
      rules={{ required: true }}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          onChange={(event, item) => {
            onChange(item);
            if(props?.salary) {
              props?.salary(item)
            }
          }}
          onBlur={props?.onChangeProp}
          value={value}
          options={props.options}
          getOptionLabel={(item) => (item.name ? item.name : '')}
          // getOptionSelected={(option, value) =>
          //   value === undefined || value === '' || option.id === value.id
          // }
          isOptionEqualToValue={(option, value) => 
              value === undefined || value === '' || option.id === value.id
            }
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              InputLabelProps={{ shrink: true }}
              label={props.placeholder}
              error={props.error ? true : false}
            />
          )}
        />
      )}
    />
    // <Controller
    //   render={({ field: { onChange, value } }) => (
    //     <Autocomplete
    //       onChange={(event, item) => {
    //         onChange(item.id);
    //       }}
    //       value={value}
    //       options={props.options}
    //       getOptionLabel={(item, key) => (item.name ? item.name : '')}
    //       getOptionSelected={(option, value) =>
    //         value === undefined || value === '' || option.id === value.id
    //       }
    //       renderInput={(params) => (
    //         <TextField
    //           {...params}
    //           label={props.placeholder}
    //           error={props.error ? true : false}
    //         />
    //       )}
    //     />
    //   )}
    //   name={props.name}
    //   {...register.register}
    //   control={props.control}
    //   rules={{ required: true }}
    // />
  );
}
